import type { LifecycleTriggerExplanation } from '../types/lifecycle';
import { formatDateTime, humanizeEventType, humanizePublicText, signedDelta } from '../utils/lifecycleFormat';

interface AnalysisReasonProps {
  explanation: LifecycleTriggerExplanation | null;
}

export function AnalysisReason({ explanation }: AnalysisReasonProps) {
  if (!explanation) {
    return (
      <section className="analysis-reason analysis-reason--missing" role="note" aria-labelledby="analysis-reason-heading">
        <h4 id="analysis-reason-heading">Proč se sem tento návrh dostal</h4>
        <p>
          Důvod postupu není u staršího záznamu dostupný.
          Jakmile systém zachytí novou událost u tohoto návrhu, doplní se sem srozumitelný popis.
        </p>
      </section>
    );
  }

  return (
    <section className="analysis-reason" role="note" aria-labelledby="analysis-reason-heading">
      <h4 id="analysis-reason-heading">Proč se sem tento návrh dostal</h4>
      <dl className="analysis-reason__facts">
        {explanation.trigger_event_type && (
          <>
            <dt>Událost</dt>
            <dd>
              <strong>{humanizeEventType(explanation.trigger_event_type)}</strong>
              {' · '}
              {formatDateTime(explanation.trigger_event_date)}
            </dd>
          </>
        )}
        {explanation.ranking_rule && (
          <>
            <dt>Pravidlo výběru</dt>
            <dd><code>{explanation.ranking_rule}</code></dd>
          </>
        )}
        {explanation.enqueued_at && (
          <>
            <dt>Zařazeno do fronty</dt>
            <dd>{formatDateTime(explanation.enqueued_at)}</dd>
          </>
        )}
        {explanation.tracking_score_after !== null && (
          <>
            <dt>Skóre</dt>
            <dd>
              {explanation.tracking_score_before !== null && (
                <>{explanation.tracking_score_before} →{' '}</>
              )}
              <strong>{explanation.tracking_score_after}</strong>
              {explanation.tracking_score_delta !== null && (
                <span className="analysis-reason__delta">
                  {' '}({signedDelta(explanation.tracking_score_delta)})
                </span>
              )}
            </dd>
          </>
        )}
        {explanation.stages_run.length > 0 && (
          <>
            <dt>Kroky kontroly</dt>
            <dd>{explanation.stages_run.join(', ')}</dd>
          </>
        )}
      </dl>
      <p className="analysis-reason__narrative">{humanizePublicText(explanation.narrative)}</p>
    </section>
  );
}
